export const UPDATE_GRAPH = 'UPDATE_GRAPH';
